import { useQuery } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const STANDING_CONSENT_ACTIVE_STATUS_KEY = 'standing-consent-active-status'

export function useStandingConsentActiveStatus() {
  return useQuery([STANDING_CONSENT_ACTIVE_STATUS_KEY], () => ApiService.PhoneStandingConsents.getActiveStatus(), {
    staleTime: 60_000,
  })
}
